import { render, staticRenderFns } from "./ManagerCardResources.vue?vue&type=template&id=11682611&scoped=true"
import script from "./ManagerCardResources.vue?vue&type=script&lang=ts"
export * from "./ManagerCardResources.vue?vue&type=script&lang=ts"
import style0 from "./ManagerCardResources.vue?vue&type=style&index=0&id=11682611&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11682611",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11682611')) {
      api.createRecord('11682611', component.options)
    } else {
      api.reload('11682611', component.options)
    }
    module.hot.accept("./ManagerCardResources.vue?vue&type=template&id=11682611&scoped=true", function () {
      api.rerender('11682611', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/managers/ManagerCardResources.vue"
export default component.exports